module.exports = ['$scope', 'ngMeta', function ($scope, ngMeta) {
  'use strict';
  $scope.$parent.breadcrumb = "Overzicht digitale Zill-toepassingen";
  $scope.$parent.title = "Overzicht digitale Zill-toepassingen";
  ngMeta.setTitle('Overzicht digitale Zill-toepassingen');

}];


// WEBPACK FOOTER //
// ./web/js/screen/support/supportOverzichtController.js